export default "__VITE_ASSET__99631bfd__"